import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import BtnGradient from 'src/components/common/button/BtnGradient';
import Barcode from 'react-barcode';
import PrintBarcode from './PrintBarcode';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

const DialogIssuanceBarcode = (props: any) => {
  const currentPrintRef = useRef(null);
    
    const showPrintPage = useReactToPrint({
      content: () => currentPrintRef.current,
    });
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='scroll-dialog-title'>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Typography fontSize={'20px'} fontWeight={500}>
            バーコードの発行
          </Typography>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={props.handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ width: '500px' }}>
        <Stack alignItems={'center'}>
          <Typography>バーコードを1枚発行しました</Typography>
          {props.data?.barcode && <Barcode value={props.data?.barcode} />}
          <Grid container spacing={3} sx={{ m: 0 }}>
            <Grid item xs={2}></Grid>
            <Grid item xs={4}>
              <Typography color={'#00000080'}>患者ID</Typography>
              <Typography>{props.data?.patient_number}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color={'#00000080'}>製造日</Typography>
              <Typography>{props.data?.creation_date}</Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ m: 0 }}>
            <Grid item xs={2}></Grid>
            <Grid item xs={4}>
              <Typography color={'#00000080'}>患者名</Typography>
              <Typography>{props.data?.patient_name}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color={'#00000080'}>保管期限</Typography>
              <Typography>{props.data?.expiry_date}</Typography>
            </Grid>
          </Grid>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: '20px' }}>
        <BtnOutlineGradient
          text='キャンセル'
          handleButtonClick={props.handleClose}
        />
        <BtnGradient text='印刷' handleButtonClick={showPrintPage} />
      </DialogActions>
      <Box style={{ 
        display: 'none' 
      }}>
        <Box ref={currentPrintRef}>
          <PrintBarcode 
        data={props.data}/>
        </Box>
      </Box>
      
    </Dialog>
  );
};

export default DialogIssuanceBarcode;
